import {
  ManifestFile,
  RemoteConfig,
  setManifest,
} from '@angular-architects/module-federation';

import { RemoteApp } from '@lib/remote-app.enum';

import './styles/boot.scss';
import './styles/less/theme.less';

const REMOTES = Object.values(RemoteApp);


function remoteEntryUrl(name: string, locale: string): string {
  return `../apps/${name}/${locale}/remoteEntry.js`;
}

// Deliberately not chained onto setManifest: this fires the session-validate request that
// gates the whole boot, and it needs no remotes.
import('./validate-session').catch(err => console.error(err));

// mt-shared transitively pulls in @angular/common and mt-core, both federation "shared"
// modules - a static import here would consume them eagerly, before the shared scope is
// initialized. Importing dynamically crosses an async boundary first.
import('mt-shared')
  .then(({ getLocale }) => {
    const locale = getLocale();

    // `true` skips eagerly fetching every remoteEntry.js; loadRemoteModule() pulls one on
    // first use. A remote that is not deployed in this environment therefore cannot delay
    // or break boot.
    const remotes: ManifestFile = Object.fromEntries(
      REMOTES.map((name): [string, RemoteConfig] => [
        name,
        { type: 'script', remoteEntry: remoteEntryUrl(name, locale) },
      ]),
    );

    return setManifest(remotes, true);
  })
  .catch(err => console.error(err))
  .then(() => import('./index.aot'))
  .catch(err => console.error(err));
